// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BQJ_g","question":"styles_question__3zQ_V","description":"styles_description__119Q6"};